import {Injectable} from '@angular/core';
import {AreaModel, CardModeModel, ClusterModel, DateListModel, GroupTypeModel} from '../analytics/analytics.model';
import {StoreModel} from '../../models/store-common.model';
import {Observable} from 'rxjs/Observable';
import {IndicatorsSearchToolbarModel} from '../../models/indicators-search-toolbar-model.model';
import {
  SearchToolbarDateFunction,
  SearchToolbarFactoryParameters,
  SearchToolbarSection
} from '../../models/search-toolbar-factory-parameters.model';

@Injectable()
export class SearchToolbarModelFactoryService {

  constructor() {}

  public buildSearchToolbarModel(
    params: SearchToolbarFactoryParameters
  ): Observable<IndicatorsSearchToolbarModel>
  {
    return new Observable((observer) => {
      let dateFunction: Observable<DateListModel>;
      switch (params.dateFunctionType) {
        case SearchToolbarDateFunction.SpDates:
          dateFunction = params.svcAnalytics.getSpDates();
          break;

        case SearchToolbarDateFunction.CsDates:
          dateFunction = params.svcAnalytics.getCsDates();
          break;

        case SearchToolbarDateFunction.VaDatesPromo:
          dateFunction = params.svcAnalytics.getVaDatesPromo(params.raggruppamento, params.finestra);
          break;

        case SearchToolbarDateFunction.VaDates:
        default:
          dateFunction = params.svcAnalytics.getVaDates(params.raggruppamento, params.finestra);
          break;
      }

      const emptyCardMode: CardModeModel = { code: '', description: '' };
      const cardModesFunction = params.disabledSections.indexOf(SearchToolbarSection.CardModes) >= 0 ?
        new Observable<CardModeModel[]>((obs) => { obs.next([emptyCardMode])}) :
        params.svcAnalytics.getCardModes();

      const emptyCluster: ClusterModel = { code: -1.0, description: '' };
      const clusterFunction = params.disabledSections.indexOf(SearchToolbarSection.Clusterlist) >= 0 ?
        new Observable<ClusterModel[]>((obs) => { obs.next([emptyCluster])}) :
        params.svcAnalytics.getClusterList();

      const groupTypeFunction = params.disabledSections.indexOf(SearchToolbarSection.GroupTypes) >= 0 ?
        new Observable<GroupTypeModel[]>((obs) => { obs.next([])}) :
        params.svcAnalytics.getGroupTypes();

      const areaFunction = params.disabledSections.indexOf(SearchToolbarSection.Areas) >= 0 ?
        new Observable<AreaModel[]>((obs) => { obs.next([])}) :
        params.svcAnalytics.getAreaList();

      const storesFunction = params.disabledSections.indexOf(SearchToolbarSection.Stores) >= 0 ?
        new Observable<StoreModel[]>((obs) => { obs.next([])}) :
        params.svcAnalytics.getStoreComboList();

      Observable.zip(
        dateFunction,
        cardModesFunction,
        clusterFunction,
        groupTypeFunction,
        areaFunction,
        storesFunction
      ).subscribe(([resDate, resCard, resCluster, resGroups, resAreas, resStores]) => {
        const res = new IndicatorsSearchToolbarModel();

        res.date_structure = resDate;
        res.cluster_list = resCluster;
        res.card_modes = resCard;
        res.group_types = [];

        resGroups.forEach(function(g) {
          res.group_types.push({
            type: g.group,
            code: g.key_code_group,
            description: g.key_desc_group,
            groups: g.subgroups.slice()
          });
        });

        res.groups = [];
        res.stores = resStores;
        res.areas = resAreas;

        // Determinazione selected start date e end date
        let lastYear = 0;
        res.date_structure.forEach(function (endDates: Date[], startDate: Date) {
          lastYear = Math.max(lastYear, startDate.getFullYear());
        });

        res.date_structure.forEach(function (endDates: Date[], startDate: Date) {
          if (startDate.getFullYear() === lastYear) {
            res.selectedStartDate = res.selectedStartDate != null && res.selectedStartDate < startDate ? res.selectedStartDate : startDate;

            endDates.forEach(function(d) {
              res.selectedEndDate = res.selectedEndDate != null && res.selectedEndDate > d ? res.selectedEndDate : d;
            });
          }
        });

        console.log(res);

        observer.next(res);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/search-toolbar-model-factory/search-toolbar-model-factory.service.ts